import type { ApolloCache } from '@apollo/client';

export const invalidateApolloFields = (cache: ApolloCache<unknown>, fieldNames: string[]) => {
  fieldNames.forEach((fieldName) => {
    cache.evict({
      id: 'ROOT_QUERY',
      fieldName,
    });
  });

  cache.gc();
};
